<template>
  <div class="bl-backdrop" v-if="isLoading">
    <div class="bl-centered">
      <i class="fa fa-spinner fa-spin inner-loading"></i>
    </div>
  </div>
</template>


<script>
export default {
  name: "BackdropLoader",
  props: {
    isLoading: {
      type: Boolean,
      required: true,
    },
  },
};
</script>

<style scoped>
.bl-backdrop {
  background-color: #6d6d6d5c;
  z-index: 1070;
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
}

.bl-centered {
  position: fixed;
  left: 50%;
  top: 50%;
  transform: translateX(-50%);
  text-align: center;
}
</style>